import React, { memo } from 'react'

import GoogleMap from 'components/GoogleMap/GoogleMap'

import { useShallowEqualSelector } from 'custom-hooks'
import { getOverviewMapCoordSelector } from 'redux/reducers/overview'

const FacilityMap = ({ hoverFacilityId, selectedDateRange, groupId }) => {
  const mapCoord = useShallowEqualSelector(getOverviewMapCoordSelector(groupId))

  return (
    <GoogleMap
      coordsMarkers={mapCoord}
      markerHoverId={hoverFacilityId}
      selectedDateRange={selectedDateRange}
    />
  )
}

export default memo(FacilityMap)
